// Clears any messages on a form field and removes any error classes
const clearSignupFieldErrorMessage = target => {
  target.classList.remove('error');
  target.setCustomValidity('');

  const formGroup = target.closest('.form_group')
  let errMsgElem;
  if (formGroup) {
    errMsgElem = formGroup.querySelector('.error-message');
  }

  if (errMsgElem) {
    errMsgElem.remove();
  }
}

const signupFormHandler = () => {
  let skipRecap = false;

  // Builds an element with certain values set on the new element
  const buildElement = opts => {
    const { nodeType, classList, attributes } = opts;
    const newElem = document.createElement(nodeType);

    if (classList) {
      for (let val of classList) {
        newElem.classList.add(val);
      }
    }

    const keys = Object.keys(attributes || {});
    for (let key of keys) {
      newElem[key] = opts.attributes[key];
    }

    return newElem;
  };


  // Displays an error for a form field and adds new element with error message
  const showErrMessageOnField = (target, msg) => {
    if (target.classList.contains('error')) {
      return;
    }

    const errElem = buildElement({
      nodeType: 'span',
      classList: ['error-message'],
      attributes: { innerHTML: msg }
    });

    target.classList.add('error');
    target.closest('.form_group').appendChild(errElem);
  };

  // Uses the validity API to display certain client side errors
  // https://caniuse.com/mdn-api_validitystate
  const getFieldValidationMessage = target => {
    if (target.validity.valueMissing)
      return target.getAttribute('data-value-missing') || '';

    if (target.validity.patternMismatch)
      return target.getAttribute('data-pattern-mismatch');

    if (target.validationMessage !== '')
      return target.validationMessage;
  };

  const getErrorKeysFromDataParam = target => {
    const param = target.getAttribute('data-param');

    if (param === 'name') {
      return ['first_name', 'last_name', 'fname', 'lname'];
    }

    return [param];
  }

  // Builds errors for user display from the API
  const buildAPIErrorsForField = (target, data) => {
    const errKeys = getErrorKeysFromDataParam(target);
    let errors = undefined;

    for (let i=0; i < errKeys.length; i++) {
      const key = errKeys[i];

      if (data.errors && data.errors[key]) {
        errors = data.errors[key];
        break;
      }
    }

    return errors;
  };

  // Builds the form data from the form, then makes a request
  // to the validation endpoint using the supplied callbacks
  const doValidationRequest = (formElem, successCb, errorCb) => {
    const formData = new FormData(formElem);

    // The validation logic requires the presence of a password, but sending it
    // over a GET request might inadvertendly cause it to get logged somewhere
    // along the way. However if the password is empty or missing, we want to
    // leave it like that, so the validation can legitimately fail.
    if (formData.get('user[password]')) {
      formData.set('user[password]', '[REDACTED]');
    }

    window.$.ajax({
      url: 'https://app.geckoboard.com/sign-up-validation',
      dataType: 'jsonp',
      data: new URLSearchParams(formData).toString(),
      success: successCb,
      error: errorCb,
    });
  }

  const isExistingAccountError = (error) => {
    return ['is already taken', 'has already been taken'].includes(error);
  };

  const parseAndDisplayErrForField = (target, data) => {
    const errors = buildAPIErrorsForField(target, data);

    if (errors) {
      const mainError = errors[0];
      const paramName = target.getAttribute('data-param-name') || 'This field';
      const customErr = [paramName, mainError + '.'];

      if (isExistingAccountError(mainError)) {
        const link = document.getElementById('app-login-link');
        const newLink = buildElement({
          nodeType: 'a',
          attributes: {
            href: link.href,
            innerText: 'Click here to login.',
          }
        });

        customErr.push(newLink.outerHTML);
      }

      target.setCustomValidity(customErr.join(' '));
      showErrMessageOnField(target, getFieldValidationMessage(target));
      return;
    }

    clearSignupFieldErrorMessage(target);
  }

  // Validates a specific field and displays any errors
  // that come back from the API for the specific field
  const validateField = (target, checkAPI, data) => {
    if (!target.validity.valid) {
      const errMsg = getFieldValidationMessage(target);
      if (errMsg) {
        showErrMessageOnField(target, errMsg);
        return;
      }
    } else {
      clearSignupFieldErrorMessage(target);
    }

    if (checkAPI) {
      // We're validating from existing response so am sync
      if (data) {
        parseAndDisplayErrForField(target, data)
      } else {
        // We're doing field specific validation so make the request async
        doValidationRequest(
          target.closest('#form-signup'),
          (data) => parseAndDisplayErrForField(target,data)
        )
      }
    };
  };

  // Valid form validates all the fields pass validity
  // and if not triggers an error display.
  // If all is valid calls out to recaptcha service
  const validateForm = (event) => {
    event.preventDefault();

    const formElem = document.getElementById('form-signup');
    const submitBtn = document.getElementById('signupBtn');
    const fieldElems = formElem.querySelectorAll('.required')

    submitBtn.setAttribute('disabled', true);
    const validateCheck = (data) => {
      let fieldsValidity = [];

      for(let field of fieldElems) {
        validateField(field, true, data)
        fieldsValidity.push(field.validity.valid)
      }

      // If all is valid we can call out to recaptcha
      if (!fieldsValidity.includes(false)) {
        if (skipRecap) {
          formElem.submit();
          return;
        }

        grecaptcha.execute();
        return;
      }

      // Reset it for re-submission as there are errors
      submitBtn.removeAttribute('disabled');
    }

    doValidationRequest(formElem, validateCheck, () => {
      submitBtn.removeAttribute('disabled');
      showErrMessageOnField(submitBtn, 'Unexpected error please try again');
    })
  };

  const trackNewSignup = () => {
    // GA3 tracking
    if (window.analytics) {
      analytics.track('Validated signup');
    }
    if (window.ga) {
      ga('create', 'UA-16139750-12');
      ga('send', 'event', 'Conversion', 'Validated signup');
    }

    // GA4/TM tracking
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'sign_up' });
    }

    // Matomo - track signup
    if (window._paq) {
      const formType = document.querySelector("input[name='metadata[signup_form]']") || {};
      window._paq.push(['trackGoal', 2]);
      window._paq.push(['FormAnalytics::trackFormConversion', '{formName}', 'form-signup']);
      window._paq.push(['trackEvent', 'Signup', 'Signup completed', formType.value]);
    }
  };

  // Prefills the email field and puts the signup form hidden
  // field if it exists as a param
  const prefillEmailAndSignupForm = formElem => {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('email');
    const signupForm = params.get('signup_form');
    skipRecap = params.get('skip_recap') === 'true';

    if (email && email.length > 0) {
      const emailElem = document.getElementById('prefilled-email-address');
      emailElem.value = email;
      emailElem.focus();
      validateField(emailElem, true);
    }

    if (signupForm && signupForm.length > 0) {
      const passwordElem = document.querySelector('input[name="user[password]"]');
      const parentElem = passwordElem.parentElement;
      const signupFormElem = buildElement({
        nodeType: 'input',
        attributes: {
          type: 'hidden',
          value: signupForm,
          name: 'user[signup_form]'
        }
      });

      parentElem.appendChild(signupFormElem);
    }
  };

  // Assumes the form is valid and submits
  // its after tracking the signup
  const submitForm = () => {
    const formElem = document.getElementById('form-signup');
    const formData = new FormData(formElem);
    trackNewSignup();

    // We can only track if the user has consented to statistics
    if ((readCookie('CookieConsent')|| '').split('%2C').includes('statistics:true')) {
      trackHubspotFormSubmission({ email: formData.get('user[email]') });
    }

    // Give some time for tracking signup
    setTimeout(() => {
      formElem.submit();
    }, 300);
  };

  // Does the initial setup on document content load
  const init = () => {
    const formElem = document.getElementById('form-signup');
    prefillEmailAndSignupForm(formElem);

    formElem.addEventListener('change', e => {
      // Clear any existing errors and reassess the validity
      clearSignupFieldErrorMessage(e.target);

      const validateOverAPI = e.target.classList.contains('validate-async')
      validateField(e.target, validateOverAPI);
    });

    formElem.addEventListener('keypress', e => {
      clearSignupFieldErrorMessage(e.target);
    });

    const signupBtn = document.getElementById('signupBtn');
    signupBtn.onclick = validateForm;
  }

  return {
    submitForm,
    init,
  }
}

const trackSignupFormViewed = (viewedFrom, modalArea) => {
  if (window._paq) {
    window._paq.push(['trackEvent', 'Signup', 'Signup form viewed', viewedFrom]);
    // TODO: Remove once we are happy with the event tracking
    window._paq.push(['trackGoal', 1]);
  }

  if (window.dataLayer) {
    window.dataLayer.push({ event: 'signup_form_viewed' });
  }
};

const trackHubspotFormSubmission = ({ email }) => {
  const hubspotCookie = readCookie('hubspotutk')

  if (!hubspotCookie) {
    return;
  }

  fetch('https://forms-eu1.hscollectedforms.net/collected-forms/submit/form', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json' },
    referrerPolicy: 'no-referrer',
    body: JSON.stringify({
      contactFields: { email },
      formSelectorId: '#form-signup',
      formValues: {},
      pageTitle: document.title,
      pageUrl: window.location.href,
      portalId: 144912244,
      utk: hubspotCookie,
      collectedFormId: 'try-geckoboard-signup-form',
      collectedFormClasses: '',
      collectedFormAction: 'submit'
    })
  });
}


document.addEventListener('DOMContentLoaded', (event) => {
  const signupFormElem = document.getElementById('form-signup');

  if (signupFormElem) {
    const handler = signupFormHandler();
    handler.init();

    // Required for the recaptcha
    window.submitSignupForm = handler.submitForm;
  }

  // Track signup form viewed when on the signup page only
  if (window.location.pathname === '/try-geckoboard/') {
    trackSignupFormViewed('Page');
  }

  const heardAboutSelect = document.getElementById('question_heard_about_us');
  const heardAboutExtraField = document.getElementById('question_heard_about_us_extra');

  // Add listener to changes to show/hide extra field
  // Also change the font color to normal on a selection
  heardAboutSelect.addEventListener("change", (evt) => {
    // Stop it showing the text as placeholder now option selected
    heardAboutSelect.style = 'color: unset;';

    const selected = heardAboutSelect.options[evt.target.selectedIndex];
    const placeholder = selected.getAttribute('data-input-placeholder');

    if (!!placeholder) {
      heardAboutExtraField.style = 'display:block';
      heardAboutExtraField.placeholder = placeholder;
      heardAboutExtraField.setAttribute('required', '');
    } else {
      heardAboutExtraField.style = 'display:none';
      heardAboutExtraField.removeAttribute('required');
      // Ensure to clear the error message incase
      // it has some validation errors
      clearSignupFieldErrorMessage(heardAboutExtraField)
    }
  });
});
